import React, { useState } from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import { FaCheckDouble } from "react-icons/fa";

import TextInput from "../../../shared/TextInput";
import CustomButton from "../../../shared/CustomButton";
import toast from "react-hot-toast";
import { maxLengthValidation } from "../../../utils/MaxLengthValidation";
import { useTranslation } from "react-i18next";
import DropdownField from "../../../shared/DropdownField";
import CheckPermission from "../../../hooks/CheckPermission";
import {
  useCreatePriceListTypeMutation,
  useUpdatePriceListTypeMutation
} from "../../../redux/api/modules/managementApi";

const CreatePriceTypeForm = ({
  selectedItemData,
  refetch,
  getPriceTypePayload,
  setOpenCreatePriceTypeModal,
  setSelectedItemData,
}) => {
  const [createPriceListType, { isLoading: isCreating }] = useCreatePriceListTypeMutation();
  const [updatePriceListType, { isLoading: isUpdating }] = useUpdatePriceListTypeMutation();
  const [isLoading, setIsLoading] = useState(false);
  const { hasPermission } = CheckPermission();
  const priceListData = [
    { label: "medical-devices", value: "medical-devices" },
    { label: "medication-codes", value: "medication-codes" },
    { label: "transportation-srca", value: "transportation-srca" },
    { label: "imaging", value: "imaging" },
    { label: "services", value: "services" },
    { label: "laboratory", value: "laboratory" },
    { label: "oral-health-op", value: "oral-health-op" },
    { label: "procedures", value: "procedures" },
  ];
  let initialValues = {
    name_en: selectedItemData?.name_en || "",
    name_ar: selectedItemData?.name_ar || "",
    category: selectedItemData?.category || "",
  };
  const { t } = useTranslation();
  const validationSchema = Yup.object().shape({
    name_en: Yup.string()
      .trim()
      .concat(maxLengthValidation(40))
      .required(t("NameENisrequired")),
    name_ar: Yup.string()
      .trim()
      .concat(maxLengthValidation(40))
      .required(t("NameARisrequired")),
    category: Yup.string().required(t("Category is required")),
  });

  const handleSubmit = async (values) => {
    const action = selectedItemData ? "update" : "create";
    if (!hasPermission("pricelist_types", action)) return;
    let payload = {
      ...values,
    };
    setIsLoading(true);
    if (selectedItemData) {
      hanldeUpdateItemType(payload);
    } else {
      handleCreateItemType(payload);
    }
  };

  const handleCreateItemType = async (payload) => {
    try {
      const res = await createPriceListType(payload).unwrap();
      if (res?.message) {
        toast.success(res?.message);
        setOpenCreatePriceTypeModal(false);
        if (typeof refetch === 'function') refetch();
      }
    } catch (err) {
      toast.error(err?.data?.message || err?.message || 'Failed to create price type');
    }
    setIsLoading(false);
  };

  const hanldeUpdateItemType = async (payload) => {
    payload.id = selectedItemData?.id;
    try {
      const res = await updatePriceListType(payload).unwrap();
      if (res) {
        toast.success(res?.message);
        setOpenCreatePriceTypeModal(false);
        setSelectedItemData(null);
        if (typeof refetch === 'function') refetch();
      }
    } catch (err) {
      toast.error(err?.data?.message || err?.message || 'Failed to update price type');
    }
    setIsLoading(false);
  };

  return (
    <div>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(props) => (
          <Form>
            <div className="grid grid-cols-2 gap-x-2 gap-y-1 mt-2">
              <TextInput
                name="name_en"
                label={t("NameEN*")}
                placeholder={t("Enterpriceitemtypename")}
                readOnly={!!selectedItemData}
              />
              <TextInput
                name="name_ar"
                label={t("NameAR*")}
                placeholder={t("Enterpriceitemtypename")}
                readOnly={!!selectedItemData}
              />
              <DropdownField
                name="category"
                label={t("Category*")}
                placeholder={t("SelectCategory")}
                options={priceListData}
                optionLabel="label"
                optionValue="value"
              />
            </div>
            <div className="flex items-center justify-end mt-3">
              {hasPermission("pricelist_types", selectedItemData ? "update" : "create") && <CustomButton
                disabled={isLoading || isCreating || isUpdating}
                type="submit"
                loading={isLoading || isCreating || isUpdating}
                icon={<FaCheckDouble size={12} className="me-2" />}
                label={
                  selectedItemData
                    ? t("UpdatePriceItemType")
                    : t("AddPriceItemType")
                }
                buttonType="primary"
              />}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default CreatePriceTypeForm;
